module.exports = __webpack_public_path__ + "img/xuqiuguangchang2.6a0e925c.png";